// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const BComplex = {
  productCode: "SBOVZ-Vitamin B Complex",
  productName: "B Complex",
  ingredients: "Garlic, Mushroom and De-oiled Sunflower seed kernel cake ",
  overview:" Orgavitaz B-Complex is an extract blend of garlic and sunflower seed kernel as core ingredient and Shiitake mushrooms as co-ingredient that offers all essential B-vitamins.",
  assay:"Natural Thiamine: 2.5 mg; Riboflavin: 2.5 mg; Natural Niacin: 6 mg; Natural Pantothenate: 4 mg; Natural Pyridoxine: 2.5 mg; Natural Cobalamin: 15 mcg",
  coNutrients:"Incidental nutrients include flavonoids, thiosulfinates, anthocyanins, eight essential amino acids, Vitamin E and Mushroom polysaccharides.",
  studies:"Comprehensive Stability studies, Permeability assays for analysing zinc absorption.",
  benefits:" Vitamin B-1 plays a role in energy metabolism and is essential for proper nerve and muscle function. Vitamin B-2 is essential for energy production and fat, carbohydrate and protein metabolism. Niacin provides dietary support for a healthy blood lipid profile. Vitamin B-6 plays a role in the maintenance of normal homocysteine levels. Folic Acid plays a role in the maintenance of normal homocysteine levels, supports your cardiovascular system. Adequate folate in a healthful diet may reduce a woman's risk of having a child with a brain or spinal cord defect. Vitamin B-12 is essential for energy production and red blood cells. Biotin functions as a coenzyme in metabolism, is required for fatty acid synthesis and provides dietary support. ",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/BComplex/BC-1.png",
    "images/Portfolio/OrgavitazForDeficiencies/BComplex/BC-2.png",
    "images/Portfolio/OrgavitazForDeficiencies/BComplex/BC-3.png",
    "images/Portfolio/OrgavitazForDeficiencies/BComplex/BC-4.png",
    "images/Portfolio/OrgavitazForDeficiencies/BComplex/BC-5.png",
    "images/Portfolio/OrgavitazForDeficiencies/BComplex/BC-6.png",



  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default BComplex;
